import { readingConstants } from './constants/readingConstants';

const readingSave = (readingsInput: any) => {
	return {
		type: readingConstants.ReadingSaveRequest,
      input: readingsInput
    };
  };
  
const readingGetDetail = (id: any) => {
	return {
		type: readingConstants.ReadingGetDetailRequest,
      input: id
    };
  };
  
const readingGetByFilter = (filterInput: any) => {
	return {
		type: readingConstants.ReadingGetByFilterRequest,
      input: filterInput
    };
};

const readingTextUpdate = (readingId: any) => {
	return { type: readingConstants.ReadingTextUpdateRequest, input: readingId }
}

const radingTitleGetExcludeByBible = (bibleId: any) => {
	return { type: readingConstants.ReadingTitleGetRequest, input:bibleId }
}
  
const readingDelete = (id: any) => {
	return {
		type: readingConstants.ReadingDeleteRequest,
      input: id
    };
};

export const readingAction = {
	readingSave,
	readingGetDetail,
	readingGetByFilter,
	readingDelete,
	readingTextUpdate,
	radingTitleGetExcludeByBible
}